import moment from 'moment'



export const formatDate = (value, format='MMM DD, YYYY [at] hh:mm A', isOffset=false) => {
  if (!value) return;
  const offset = isOffset ? 0 : moment().utcOffset(String(value))._offset
  let formattedDate = moment(String(value))
      .utcOffset(offset)
      .format(format)
  
  return formattedDate;
};